import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "inherit",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "m19.81 18.016-.772.772c-.488.5-1.096.863-1.765 1.055a4 4 0 0 1-2.051.045 13.3 13.3 0 0 1-3.906-1.768 18 18 0 0 1-3.085-2.505 18.8 18.8 0 0 1-2.305-2.784A14.3 14.3 0 0 1 4.2 9.268a4.1 4.1 0 0 1-.086-2.232 4.1 4.1 0 0 1 1.093-1.943l.904-.905a.646.646 0 0 1 .911 0l2.843 2.874a.64.64 0 0 1 0 .912l-1.67 1.691a1.4 1.4 0 0 0-.145 1.782 20.3 20.3 0 0 0 4.631 4.585 1.37 1.37 0 0 0 1.753-.153l1.615-1.656a.646.646 0 0 1 .91 0l2.85 2.881a.64.64 0 0 1 .14.703.6.6 0 0 1-.14.209" }, null, -1)
  ])))
}
export default { render: render }